import React from 'react'
 import { MCCategories } from '_constants'
import { CategoryTab } from 'MessageCenter'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { messageCenterActions } from '_actions';


class CategoryList extends React.Component {
    render() {
        const list = Object.keys(MCCategories)
        .filter(key => { return MCCategories[key].enabled === true })
        .map((key) => {
            var category=MCCategories[key];
            return (
                <CategoryTab
                    key={category.id}
                    categoryId={category.id}
                    entityKey={category.entityKey}
                    name={category.name}
                    changeCategory={this.props.changeCategory}
                    selected={this.props.selectedCategory === category.id ? true : false} />
            );
        });

        return (
            <div>
                {list}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeCategory: bindActionCreators(messageCenterActions.categoryChange, dispatch)
    };
}

const connectedCategoryList = connect(null, mapDispatchToProps)(CategoryList);
export { connectedCategoryList as CategoryList };
